import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {API_ENDPOINTS, baseHost} from "../../constants/common";

export const AISearchActionTypes = {
  FETCH_RESULTS: "AISearch/fetchResults",
  RESET_RESULTS: "AISearch/reset",
  SAVE_HOUSINGS_COLLECTION: "AISearch/housingsCollection/save",
};

type FetchArg =
  | string
  | {
      query: string;
      page?: number;
      perPage?: number;
    };

export const AISearchActionCreator = {
  fetchAISearchResults: createAsyncThunk(
    AISearchActionTypes.FETCH_RESULTS,
    async (arg: FetchArg, { rejectWithValue }) => {
      try {
        const {
          query,
          page = 1,
          perPage = 10,
        } = typeof arg === "string"
          ? { query: arg, page: 1, perPage: 10 }
          : arg;

        const response = await axios.post(API_ENDPOINTS.aiSearch, {
          query,
          page,
          perPage,
        });
        return response.data;
      } catch (error: any) {
        return rejectWithValue(
          error?.response?.data || "Ошибка при выполнении AI-поиска",
        );
      }
    },
  ),

  saveHousingsCollection: createAsyncThunk(
    AISearchActionTypes.SAVE_HOUSINGS_COLLECTION,
    async (
      { data, userId }: { data: any; userId?: string | number | null },
      { rejectWithValue },
    ) => {
      try {
        const response = await axios.post(
          `${baseHost}/api/v1/collection`,
          {
            content: data,
            user_id: userId,
          },
        );
        return response.data;
      } catch (error: any) {
        return rejectWithValue(
          error?.response?.data || "Ошибка при сохранении подборки",
        );
      }
    },
  ),

  resetResults: createAction(AISearchActionTypes.RESET_RESULTS),
};
